import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    sections:null,
    section:null,
    loading: false,
    error:null
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.FETCH_SECTIONS_BEGIN:
            return updateObject(state, {loading:true, error:null});
        case actionTypes.FETCH_SECTIONS_SUCCESS: 
            return updateObject(state, {loading:false, sections:action.payload.sections});
        case actionTypes.FETCH_SECTIONS_FAILED: 
            return updateObject(state, {loading:false, error:action.payload.error, sections:null});
        case actionTypes.FETCH_SECTION_BEGIN:
            return updateObject(state, {loading:true, error:null});
        case actionTypes.FETCH_SECTION_SUCCESS: 
            return updateObject(state, {loading:false, section:action.payload.section});
        case actionTypes.FETCH_SECTION_FAILED: 
            return updateObject(state, {loading:false, error:action.payload.error, section:null});
        case actionTypes.UPDATE_SECTION_BEGIN:
            return updateObject(state, {loading:true, error:null});
        case actionTypes.UPDATE_SECTION_SUCCESS: 
            var updatedSections = state.sections.map((item, index) => {
                if (item.id !== action.payload.section.id) {
                    return item;
                }
                return {...item, ...action.payload.section}
            });
            return updateObject(state, {loading:false, sections:updatedSections, section:action.payload.section});
        case actionTypes.UPDATE_SECTION_FAILED: 
            return updateObject(state, {loading:false, error:action.payload.error, sections:null});
        case actionTypes.ADD_SECTION_BEGIN:
            return updateObject(state, {loading:true, error:null});
      case actionTypes.ADD_SECTION_SUCCESS:
        
        //console.log(action.payload.section);
        return {
          ...state,
          loading: false,
          sections: [
              ...state.sections.slice(0, 0),
              action.payload.section,
              ...state.sections.slice(0),
          ]
        }
        case actionTypes.ADD_SECTION_FAILED:
            return updateObject(state, {loading:false, error:action.payload.error});
        default: 
            return state;
    }
};

export default reducer; 


// WEBPACK FOOTER //
// ./src/store/reducers/section.js